import script from "./PublicUserReviewFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicUserReviewFormView.vue?vue&type=script&setup=true&lang=js"

import "./PublicUserReviewFormView.vue?vue&type=style&index=0&id=b40900e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b40900e2"]])

export default __exports__